import { Node } from '@tiptap/core';

export const PageBreakExtension = Node.create({
  name: 'physicalPageBreak',

  group: 'block',
  
  atom: true, // Нельзя редактировать содержимое
  
  selectable: false, // Нельзя выделить

  parseHTML() {
    return [
      { tag: 'div[data-type="physical-page-break"]' },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', {
      'data-type': 'physical-page-break',
      class: 'page-break physical-page-break',
      'aria-hidden': 'true',
      style: [
        'display:block',
        'padding:0',
        'background:transparent',
        'border:none',
        'color:transparent',
        'font-size:1px',
        'line-height:1px',
        'user-select:none',
        'pointer-events:none',
        'page-break-before:always',
        'break-before:page',
        'overflow:hidden',
        'box-sizing:border-box',
        'position:relative'
      ].join(';')
    }];
  },

  addCommands() {
    return {
      // Backward-compatible alias used in the toolbar
      insertPageBreak: () => ({ tr, dispatch, state, editor }) => {
        // Prefer inserting a pageSpacer that fills remaining space on the page
        const spacerType = state.schema.nodes.pageSpacer;
        if (spacerType) {
          try {
            const view = editor?.view;
            if (view) {
              const selDom = view.domAtPos(state.selection.from);
              const editorRect = view.dom.getBoundingClientRect();
              const selNode = selDom.node instanceof Element ? selDom.node : view.dom;
              const selRect = (selNode instanceof Element ? selNode.getBoundingClientRect() : editorRect);
              const yWithinEditor = selRect.top - editorRect.top;
              // In fullscreen, content area inside A4 is 1003px; otherwise approximate using 1003 as well
              const PAGE_CONTENT_HEIGHT = 1003;
              const yOnPage = ((yWithinEditor % PAGE_CONTENT_HEIGHT) + PAGE_CONTENT_HEIGHT) % PAGE_CONTENT_HEIGHT;
              const spacerHeight = Math.max(0, PAGE_CONTENT_HEIGHT - Math.round(yOnPage));
              if (dispatch) {
                const node = spacerType.create({ height: spacerHeight, locked: true });
                tr = tr.replaceSelectionWith(node);
                dispatch(tr);
                return true;
              }
              return true;
            }
          } catch (e) {
            // fallback below
          }
        }
        // Fallback to physical page break atom
        if (dispatch) {
          const node = this.type.create();
          tr.replaceSelectionWith(node);
          dispatch(tr);
        }
        return true;
      },
      insertPhysicalPageBreak: () => ({ tr, dispatch }) => {
        if (dispatch) {
          const node = this.type.create();
          tr.replaceSelectionWith(node);
          dispatch(tr);
        }
        return true;
      },
      
      removeAllPhysicalPageBreaks: () => ({ tr, dispatch, state }) => {
        if (dispatch) {
          let transaction = tr;
          let deleteCount = 0;
          
          // Проходим по документу и удаляем все page break nodes
          state.doc.descendants((node, pos) => {
            if (node.type.name === 'physicalPageBreak') {
              transaction = transaction.delete(pos - deleteCount, pos + node.nodeSize - deleteCount);
              deleteCount += node.nodeSize;
            }
          });
          
          dispatch(transaction);
        }
        return true;
      }
    };
  },

  addKeyboardShortcuts() {
    return {
      'Mod-Shift-Enter': () => this.editor.commands.insertPageBreak(),
    };
  },
});

export default PageBreakExtension;
